<template>
<loader v-if="isLoading" class="loaderbg"></loader>

<div v-else>
    <navBarViewVue></navBarViewVue>

    <div class="winnersSecBgColor">
        <div class="row align-items-center winner-Hdr">

            <div class="col-md-1 col-2 text-center m-auto">
                <router-link :to="{ name: 'home' }">
                    <i class="fa-solid fa-arrow-left back-arrow"></i>
                </router-link>

                <router-link :to="{ name: 'home' }">
                    <i class="fas fa-chevron-left cheveron-icon"></i>
                </router-link>
            </div>
            <div class="col-md-10 col-8 text-center winnerHdrTxt">Winners</div>
            <div class="col-md-1 col-2"></div>
        </div>
        <div class="winnersBgStyles">

            <div class="sec-bg">
                <div class="card-pdng">
                    <div class="winner-card m-auto">
                        <h2 class="winner-countTxt"> {{ convert_count(winnersMonthDetails.totalWinners) }} WINNERS SO FAR</h2>
                        <h3 class="winner-subTxt">COULD YOU BE NEXT?</h3>
                    </div>
                </div>

                <div>
                    <span class="d-flex justify-content-center align-items-center topWinner-hdr">
                        <i class="fas fa-award"></i>
                        <h3 class="topWinner-txt mb-0">Latest Winners</h3>
                    </span>
                </div>

                <div class="center" v-if="winnersMonthwiseDetails.length > 0">
                    <div v-for="item in winnersMonthwiseDetails" :key="item" class="slick-slide winnersSlick">
                        <div class="card-dsgn">
                            <div class="text-center">
                                <img :src="`${urlLink}${item.MiniImageUrl}`" alt="" class="user-img">
                                <h2 class="user-nameTxt">{{ formatName(item.Name) }}</h2>
                                <h5 class="itemWon-txt winnersText_ellipsis">{{ item.Title }}</h5>
                                <button v-if="item.type == 'Instant'" type="button" class="btn draw-btn" @click="goToDrawDetails(item)">
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImg.svg" class="drawImgLight" alt="">
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImgDarkTheme.svg" class="drawImgDark" alt="">

                                    Raffle details</button>
                                <button v-else type="button" class="btn draw-btn" @click="goToDrawDetails(item)">
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImg.svg" class="drawImgLight" alt="">
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImgDarkTheme.svg" class="drawImgDark" alt="">
                                    Draw details</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <winnersMonthNew></winnersMonthNew>
        </div>
    </div>
    <footerViewVue></footerViewVue>
</div>
</template>

<script>
import {
    apiURL
} from "@/api/allApis"

import footerViewVue from '../HomePage/footerView.vue';
import navBarViewVue from '../HomePage/navBarView.vue';
import winnersMonthNew from "@/components/WinnerswithoutLogin/winnersMonthNew.vue";
import {
    urlLink
} from '@/s3bucket.js';
import {
    mapActions,
    mapGetters
} from "vuex";
import loader from "@/components/ReusableComponents/loader.vue"
import $ from "jquery";
import "slick-carousel/slick/slick.min.js";
import "slick-carousel/slick/slick.css";
import "@/assets/css/winnerPage.css";
import "@/assets/slick/slick.css";
import "@/assets/slick/slick-theme.css"
export default {
    data: () => ({
        winnersMonthDetails: {},
        winnersMonthwiseDetails: [],
        urlLink: urlLink,
        userSession: "",
        isLoading: true,
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmContent: null,
        utmTerm: null

    }),
    components: {
        winnersMonthNew,
        navBarViewVue,
        footerViewVue,
        loader

    },

    created() {
        if (this.$route.query.utm_source) {
            this.utmSource = this.$route.query.utm_source;
            sessionStorage.setItem('utm_source', this.utmSource);
        }

        if (this.$route.query.utm_medium) {
            this.utmMedium = this.$route.query.utm_medium;
            sessionStorage.setItem('utm_medium', this.utmMedium);
        }

        if (this.$route.query.utm_campaign) {
            this.utmCampaign = this.$route.query.utm_campaign;
            sessionStorage.setItem('utm_campaign', this.utmCampaign);
        }
        if (this.$route.query.utm_content) {
            this.utmContent = this.$route.query.utm_content;
            sessionStorage.setItem('utm_content', this.utmContent);
        }
        if (this.$route.query.utm_term) {
            this.utmTerm = this.$route.query.utm_term;
            sessionStorage.setItem('utm_term', this.utmTerm);
        }

        this.userSession = localStorage.getItem("user_session");

        if (this.userSession) {
            this.$store.dispatch("validate_Token", this.userSession);
            this.validateToken();
        } else {
            localStorage.removeItem("user_session");

            const queryParams = {};

            if (sessionStorage.getItem('utm_source')) queryParams.utm_source = sessionStorage.getItem('utm_source');
            if (sessionStorage.getItem('utm_medium')) queryParams.utm_medium = sessionStorage.getItem('utm_medium');
            if (sessionStorage.getItem('utm_campaign')) queryParams.utm_campaign = sessionStorage.getItem('utm_campaign');
            if (sessionStorage.getItem('utm_content')) queryParams.utm_content = sessionStorage.getItem('utm_content');
            if (sessionStorage.getItem('utm_term')) queryParams.utm_term = sessionStorage.getItem('utm_term');
            this.$router.push({
                name: 'winnersWithoutLogin',
                query: queryParams
            });

            this.fetch_WinnersMonthwiseData()
            this.fetch_winnersMonth();

        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

    },
    mounted() {
        const currentPath = this.$route.path;
        if (currentPath !== '/') {
            const chatWidgetContainer = document.getElementById('chat-widget-container');
            if (chatWidgetContainer) {
                chatWidgetContainer.style.display = 'none';
            }
        }
    },
    watch: {
        winnersMonthwiseDetails: {
            handler() {
                this.$nextTick(() => {
                    this.initializeSlickCarousel();
                });
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(["getValidateTokenData"]),
    },

    methods: {
        ...mapActions(['validate_Token']),
        async validateToken() {
            await this.validate_Token(this.userSession);

            if (this.getValidateTokenData) {
                const queryParams = {};

                if (sessionStorage.getItem('utm_source')) queryParams.utm_source = sessionStorage.getItem('utm_source');
                if (sessionStorage.getItem('utm_medium')) queryParams.utm_medium = sessionStorage.getItem('utm_medium');
                if (sessionStorage.getItem('utm_campaign')) queryParams.utm_campaign = sessionStorage.getItem('utm_campaign');
                if (sessionStorage.getItem('utm_content')) queryParams.utm_content = sessionStorage.getItem('utm_content');
                if (sessionStorage.getItem('utm_term')) queryParams.utm_term = sessionStorage.getItem('utm_term');
                this.$router.push({
                    name: 'winnersWithLogin',
                    query: queryParams
                });

            } else {

                localStorage.removeItem("user_session");
                const queryParams = {};

                if (sessionStorage.getItem('utm_source')) queryParams.utm_source = sessionStorage.getItem('utm_source');
                if (sessionStorage.getItem('utm_medium')) queryParams.utm_medium = sessionStorage.getItem('utm_medium');
                if (sessionStorage.getItem('utm_campaign')) queryParams.utm_campaign = sessionStorage.getItem('utm_campaign');
                if (sessionStorage.getItem('utm_content')) queryParams.utm_content = sessionStorage.getItem('utm_content');
                if (sessionStorage.getItem('utm_term')) queryParams.utm_term = sessionStorage.getItem('utm_term');
                this.$router.push({
                    name: 'winnersWithoutLogin',
                    query: queryParams
                });

                this.fetch_WinnersMonthwiseData()
                this.fetch_winnersMonth()
            }
        },
        formatName(nameString) {
            const [firstName, lastName] = nameString.split(" ");
            const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
            const formattedLastNameInitial = lastName ? ` ${lastName.charAt(0).toUpperCase()}` : "";

            return `${formattedFirstName}${formattedLastNameInitial}`;
        },
        initializeSlickCarousel() {
            $('.center').slick({
                variableWidth: true,
                arrows: true,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 3,
                prevArrow: "<div class='winnersPageLeftArrowBg'><button class='slick-prev slick-arrow' aria-label='Previous' type='button' >Previous</button></div>",
                nextArrow: "<div class='winnersPageRightArrowBg'><button class='slick-next slick-arrow' aria-label='Next' type='button' >Next</button></div>",
                responsive: [{
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            dots: true,
                            arrows: false,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 1
                        }
                    }
                ]
            });

            const slickSlides = document.querySelectorAll(".slick-cloned");

            slickSlides.forEach(slide => {
                slide.style = "";
            });
        },
        convert_count(val) {
            return Number(val).toLocaleString();
        },
        goToDrawDetails(item) {
            if (item.type == "final") {
                this.$router.push({
                    name: "drawDetailsWithoutLogin",
                    params: {
                        drawCode: item.DrawCode
                    },
                });
            } else if (item.type == "Instant") {
                this.idArray = item;
                this.$router.push({
                    name: "App",
                    params: {
                        category: this.idArray.CategoryName,
                        id: this.idArray.RaffleCode,
                        slug: this.idArray.slug
                    },
                });
            }
        },

        async fetch_WinnersMonthwiseData() {
            try {
                fetch(
                        apiURL.winnersMonthwiseDetailsWithoutLogin, {
                            method: "POST",
                            headers: {
                                "Content-type": "application/json; charset=UTF-8",

                            },
                        }
                    )
                    .then((response) => response.json())
                    .then((data) => {

                        this.winnersMonthwiseDetails = data;
                        this.isLoading = false;
                    });
            } catch (error) {
                this.isLoading = false;
            }
        },
        async fetch_winnersMonth() {
            try {
                fetch(apiURL.winnersMonthWithoutLogin, {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",

                        },
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        this.winnersMonthDetails = data;
                        this.isLoading = false;

                    });
            } catch (error) {
                this.isLoading = false;
            }
        },

    },
};
</script>

<style>
.slick-dots li {
    position: relative;
    display: inline-block;
    width: 5px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
}

.individual-indicators>.slide {
    display: inline-block;
}

.winnersPageLeftArrowBg {
    width: 311px;
    height: 445px;
    position: absolute;
    z-index: 1020;
    background: linear-gradient(269deg, rgba(238, 238, 238, 0.00) 10%, #F2F2F3 100%);
    pointer-events: none;
}

.dark .winnersPageLeftArrowBg {
    background: linear-gradient(269deg, rgba(0, 6, 22, 0.00) 0%, #000616 100%);
}

.winnersPageRightArrowBg {
    width: 311px;
    height: 445px;
    position: absolute;
    z-index: 1020;
    background: linear-gradient(90deg, rgba(238, 238, 238, 0.00) 10%, #F2F2F3 100%);
    right: 0;
    top: 0;
    pointer-events: none;
}

.dark .winnersPageRightArrowBg {
    background: linear-gradient(90deg, rgba(0, 6, 22, 0.00) 0%, #000616 100%);
}

.slick-slide.slick-active.winnersSlick {
    width: 302px !important;
    box-sizing: border-box;
    margin: 20px;
}

.slick-slide.winnersSlick {
    width: 302px !important;
    margin: 20px !important;
}

.slick-next {
    right: 56px !important;
    width: 48px;
    height: 48px;
    background: #fff !important;
    border-radius: 50%;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.25));
    pointer-events: fill;
}

.dark .slick-next {
    background: #0e1123 !important;
}

.slick-next:before {
    content: '\f054';
    color: rgb(0, 0, 0, 0.8) !important;
}

.dark .slick-next:before {
    color: #fff !important;
}

.slick-prev {
    left: 56px !important;
    color: red !important;
    z-index: 9999 !important;
    width: 48px;
    height: 48px;
    background: #fff !important;
    border-radius: 50%;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.25));
    pointer-events: fill;
}

.dark .slick-prev {
    background: #0e1123 !important;
}

.slick-prev:before {
    content: '\f053';
    color: rgb(0, 0, 0, 0.8) !important;
}

.dark .slick-prev:before {
    color: #fff !important;
}

.slick-prev:hover {
    color: #000 !important;
}

.slick-prev:before,
.slick-next:before {
    font-family: 'Font Awesome 6 Pro' !important;
    font-size: 16px;
    line-height: 1;
    opacity: .75;
    color: #000 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@media (max-width:767px) {
    .slick-active>div.card-dsgn {
        width: 216px;
        min-height: 280px;
        margin: auto;
    }

    .slick-active>div>div>img.user-img {
        width: 140px;
        height: 140px;
        margin: 9px auto;
    }

    .slick-active>div>div>div.user-nameTxt {
        font-size: 16px;
        margin: 8px 0px 5px;
    }

    .slick-active>div>div>div.itemWon-txt {
        font-size: 12px;
        margin-bottom: 13px;
    }

    .slick-active>div>div>div.draw-btn {
        font-size: 12px;
        width: 140px;
        height: 32px;

    }

    .slick-active>div>div>img.drawImgLight {
        width: 9px !important;
        height: 12px !important;
        margin-right: 6px;
    }

    .slick-active>div>div>img.drawImgDark {
        width: 9px !important;
        height: 12px !important;
        margin-right: 6px;
    }

    .slick-slide.slick-active.winnersSlick {
        width: 216px !important;
        box-sizing: border-box;
        margin: 8px;
    }

    .slick-slide.winnersSlick {
        width: 216px !important;
        margin: 8px !important;
    }

    .winnersPageLeftArrowBg {
        display: none !important;
    }

    .winnersPageRightArrowBg {
        display: none !important;
    }
}
</style>
